import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MyOrganisationComponent } from './components/my-organisation/my-organisation.component';
import { AdminComponent } from './admin.component';
import { MyAccountComponent } from './components/myaccount/my-account.component';
import { OrganisationsComponent } from './components/organisations/organisations.component';
import { RoleGuardService } from '../auth/services/role.guard';

const adminRoutes: Routes = [
  {
    path: 'admin',
    component: AdminComponent,
    children: [
      {
        path: '',  component: MyAccountComponent, canActivate: [RoleGuardService], data: { expectedRole: 'Basic' }
      },
      {
        path: 'myorganisation', component: MyOrganisationComponent, canActivate: [RoleGuardService], data: { expectedRole: 'Admin' }
      },
      {
        path: 'organisations', component: OrganisationsComponent, canActivate: [RoleGuardService], data: { expectedRole: 'SuperAdmin' }
      }
    ]
  }
];

export const adminRouting: ModuleWithProviders = RouterModule.forChild(adminRoutes);



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin.routing.ts